var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"copywriting"}},[_c('div',{staticClass:"pc"},[_c('toptab',{attrs:{"topback":true}}),_c('div',{staticClass:"copywritingbox"},[_c('div',{staticClass:"copywritingboxleft"},[_c('asidebar')],1),_c('div',{staticClass:"copywritingboxright"},[_c('articlebox')],1)])],1),_c('div',{staticClass:"mobile"},[_c('copywritingm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }